import { Grid, Typography, useTheme } from "@mui/material"

const Header = ({
  logoResult,
  t,
  workorderResult: {
    data: { id }
  }
}) => {
  const theme = useTheme()
  return (
    <Grid container alignItems="center" justifyContent="space-between">
      <Grid item display="flex" alignItems="center">
        <Typography fontWeight={400} variant="h1">
          {t("global.workorder", "Workorder")}
        </Typography>
        <Typography sx={{ color: theme.palette.primary[700], ml: 1 }} variant="h1">
          #{id}
        </Typography>
      </Grid>
      <Grid item>
        {logoResult.status === 2 && (
          <img
            src={`data:${logoResult.data.contenType};base64,${logoResult.data.base64Contents}`}
            width={75}
            alt=""
          />
        )}
      </Grid>
    </Grid>
  )
}

export default Header
